import request from '@/utils/request';

function deliveryTimeReport(domainID, year) {
  return request({
    method: 'get',
    url: `delivery-time/${domainID}/${year}`,
    responseType: 'blob'
  });
}

function fabricReport(domainID) {
  return request({
    method: 'get',
    url: 'report/fabrics',
    params: {
      domainID: domainID
    },
    responseType: 'blob',
    timeout: 60000
  });
}

function orderReport(domainID, startDate, endDate, statusID, planningOption) {
  return request({
    method: 'get',
    url: 'report/orders',
    params: {
      domainID: domainID,
      startDate: startDate,
      endDate: endDate,
      statusID: statusID,
      planningOption: planningOption
    },
    responseType: 'blob',
    timeout: 600000
  });
}

function orderReportVolume(domainID, year) {
  return request({
    method: 'get',
    url: `order-report-volume/${domainID}/${year}`,
    responseType: 'blob'
  });
}

function clientSalesReport(domainID, year, workshopID) {
  return request({
    method: 'get',
    url: `client-sales-report/${domainID}/${year}`,
    params: {
      workshopID: workshopID
    },
    responseType: 'blob'
  });
}

function deliveryReport(domainID, year, workshopID) {
  return request({
    method: 'get',
    url: `delivery-report/${domainID}/${year}`,
    params: {
      workshopID: workshopID
    },
    responseType: 'blob'
  });
}

function orderedMetersReport(domainID, year) {
  return request({
    method: 'get',
    url: `ordered-meters-report/${domainID}/${year}`,
    responseType: 'blob'
  });
}

function returnReport(domainID, year) {
  return request({
    method: 'get',
    url: `return-report/${domainID}/${year}`,
    responseType: 'blob'
  });
}

export const storeExtensions = {
  actions: {
    deliveryTimeReport({ dispatch }, { domainID, year }) {
      return new Promise((resolve, reject) =>
        deliveryTimeReport(domainID, year)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    fabricReport({ dispatch }, { domainID }) {
      return new Promise((resolve, reject) =>
        fabricReport(domainID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    orderReport({ dispatch }, { domainID, startDate, endDate, statusID, planningOption }) {
      return new Promise((resolve, reject) =>
        orderReport(domainID, startDate, endDate, statusID, planningOption)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    orderReportVolume({ dispatch }, { domainID, year }) {
      return new Promise((resolve, reject) =>
        orderReportVolume(domainID, year)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    clientSalesReport({ dispatch }, { domainID, year, workshopID }) {
      return new Promise((resolve, reject) =>
        clientSalesReport(domainID, year, workshopID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    deliveryReport({ dispatch }, { domainID, year, workshopID }) {
      return new Promise((resolve, reject) =>
        deliveryReport(domainID, year, workshopID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    orderedMetersReport({ dispatch }, { domainID, year }) {
      return new Promise((resolve, reject) =>
        orderedMetersReport(domainID, year)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    returnReport({ dispatch }, { domainID, year }) {
      return new Promise((resolve, reject) =>
        returnReport(domainID, year)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
